import { QueryClient } from "@tanstack/react-query";

/**
 * Standard cache configuration for React Query (TanStack Query).
 * Use for data that changes infrequently and is safe to cache client-side.
 */
export const STANDARD_QUERY_CACHE_CONFIG = {
  staleTime: 60 * 60 * 1000, // 1 hour
  gcTime: 60 * 60 * 1000, // 1 hour
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

/** The standalone app's client. Hosts such as azul pass their own to `LendingProviders`. */
export const defaultQueryClient = new QueryClient();
